import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../components/tag/Layout";
import { HeroBg, EyebrowPill, SectionPill } from "../components/tag/Primitives";

export default function About() {
  return (
    <Layout title="About | The Authority Gap" path="/about">
      <section style={{ background: "#090909", padding: "70px 32px 44px", position: "relative", overflow: "hidden", textAlign: "center" }}>
        <HeroBg />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 720, margin: "0 auto" }}>
          <div style={{ marginBottom: 22 }}><EyebrowPill>About</EyebrowPill></div>
          <h1 className="tag-h1" style={{ marginBottom: 14 }}>The smartest people in every industry shouldn&apos;t be the hardest to find.</h1>
          <p style={{ color: "#aaa", fontSize: 15, lineHeight: 1.6 }}>
            The Authority Gap is the system we build for credentialed experts who watch generalists out-rank them online.
            One framework. Six proven Labs. A growing toolkit you can buy at $19 — or have us build for you at $7,500.
          </p>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "44px 20px" }}>
        <div className="tag-two-col" style={{ maxWidth: 1000, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 44, alignItems: "start" }}>
          <div>
            <div style={{ marginBottom: 14 }}><SectionPill>The Why</SectionPill></div>
            <h2 className="tag-h2" style={{ marginBottom: 18 }}>The internet rewards visibility before credibility.</h2>
            <p className="tag-body" style={{ marginBottom: 14 }}>
              A 20-year physician with no content strategy loses to a 6-month creator with a posting
              schedule. A senior compliance officer loses to a confident generalist. A specialist coach
              loses to an algorithm-friendly creator.
            </p>
            <p className="tag-body">
              This isn&apos;t a talent problem. It&apos;s a systems problem. AuthorityOS is the system.
            </p>
          </div>
          <div className="tag-card" style={{ padding: 28 }}>
            <div style={{ color: "#FF6575", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>Operating principles</div>
            <ul style={{ color: "#bbb", fontSize: 13, lineHeight: 1.8, paddingLeft: 18, margin: 0 }}>
              <li>Build assets you own, not channels you rent.</li>
              <li>Sequence the seven Authority Assets so each makes the next easier.</li>
              <li>Use frameworks, not tactics. Tactics decay; systems compound.</li>
              <li>Document everything. Transparency is a competitive advantage.</li>
              <li>Run experiments in public. Honesty beats polish.</li>
            </ul>
          </div>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "44px 20px" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <div style={{ marginBottom: 14 }}><SectionPill>The labs</SectionPill></div>
          <h2 className="tag-h2" style={{ marginBottom: 18 }}>Proven across six industries.</h2>
          <p className="tag-body" style={{ marginBottom: 20 }}>
            We don&apos;t just teach the framework — we run it. Every Lab in the portfolio is a working deployment
            of AuthorityOS in a different niche: healthcare (MetabolicLabOS), education (BeaconsIEP), finance
            (Build Ready), compliance (AASC), sports (ChalkOS), and enterprise (Kaiya Solutions).
          </p>
          <Link to="/portfolio" className="btn-primary">See all six labs →</Link>
        </div>
      </section>

      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "56px 20px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", textAlign: "center" }}>
          <h2 className="tag-h2" style={{ marginBottom: 16 }}>Want to find your gap?</h2>
          <p className="tag-body" style={{ marginBottom: 22 }}>The free Authority Gap Score takes 3 minutes and produces a personalized report. If your gap is bigger than expected, the next step is the $49 AI-generated Audit.</p>
          <Link to="/score" className="btn-primary">Take the Authority Score</Link>
        </div>
      </section>
    </Layout>
  );
}
